import { render, staticRenderFns } from "./DateRenderer.vue?vue&type=template&id=561236f6&"
import script from "./DateRenderer.vue?vue&type=script&lang=js&"
export * from "./DateRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports